// stores/salesStore.js
import { create } from "zustand";
import axiosToken from "../api/axiosClient";
import { toast } from "react-toastify";

const salesStore = create((set, get) => ({
  // États de chargement
  isLoadingPayments: false,
  isLoadingSales: false,
  isLoadingPurchases: false,
  isLoadingCreatePayment: false,
  isLoadingDailySummary: false,
  isLoadingUnpaidReservations: false,

  // Données

  allPurchasesUser: [],
  payments: [],
  sales: [],
  allPayments: [],
  dailySummary: null,
  unpaidReservations: [],

  // Fonction utilitaire pour calculer le montant d'une réservation
  calculateReservationAmount: (reservation) => {
    if (!reservation || !reservation.appointmentServices) return 0;

    // console.log("appointmentServices: ", reservation.appointmentServices);

    return reservation.appointmentServices.reduce((total, service) => {
      const servicePrice = service.price || service.unitPrice || 0;
      const quantity = service.quantity || service.quantity || 1;
      return total + servicePrice * quantity;
    }, 0);
  },

  // Récupérer les réservations impayées
  getUnpaidReservations: async () => {
    set({ isLoadingUnpaidReservations: true });

    try {
      const response = await axiosToken.get("/reservation/unpaid/list");
      const unpaidData = response.data?.data || [];

      set({
        unpaidReservations: unpaidData,
        isLoadingUnpaidReservations: false,
      });

      return unpaidData;
    } catch (error) {
      console.error("Erreur getUnpaidReservations :", error);
      toast.error(
        error?.response?.data?.error ||
          "Erreur lors du chargement des réservations impayées.",
      );
      set({ isLoadingUnpaidReservations: false });
      return [];
    }
  },

  // Récupérer les paiements avec today/tomorrow par défaut
  getPaymentsWithDateRange: async (startDate = null, endDate = null) => {
    set({ isLoadingPayments: true });

    try {
      const params = {};

      // Par défaut: aujourd'hui et demain
      const today = new Date();
      const tomorrow = new Date(today);
      const lastday = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      lastday.setDate(lastday.getDate() - 1);

      if (startDate || endDate) {
        params.startDate = startDate || lastday.toISOString().split("T")[0];
        params.endDate = endDate || tomorrow.toISOString().split("T")[0];
      } else {
        // params.startDate = today.toISOString().split('T')[0];
        // params.endDate = tomorrow.toISOString().split('T')[0];
      }

      // console.log({ params });

      const response = await axiosToken.get("/payments/only/payment", {
        params,
      });
      const paymentsData = response.data?.data || [];

      // console.log({ paymentsData });

      set({
        payments: paymentsData,
        isLoadingPayments: false,
      });

      return paymentsData;
    } catch (error) {
      console.error("Erreur getPaymentsWithDateRange :", error);
      toast.error(
        error?.response?.data?.error ||
          "Erreur lors du chargement des paiements.",
      );
      set({ isLoadingPayments: false });
      return [];
    }
  },

  // Récupérer les ventes avec today/tomorrow par défaut
  getSalesWithDateRange: async (startDate = null, endDate = null) => {
    set({ isLoadingSales: true });

    try {
      const params = {};

      // Par défaut: aujourd'hui et demain
      //   const today = new Date();
      //   const tomorrow = new Date(today);
      //   const lastday = new Date(today);
      //   tomorrow.setDate(tomorrow.getDate() + 1);
      //   lastday.setDate(lastday.getDate() - 1);

      params.startDate = startDate;
      params.endDate = endDate;

      //   if (startDate || endDate) {
      //     params.startDate = startDate || lastday.toISOString().split("T")[0];
      //     params.endDate = endDate || tomorrow.toISOString().split("T")[0];
      //   } else {
      //     params.startDate = today.toISOString().split('T')[0];
      //     params.endDate = tomorrow.toISOString().split('T')[0];
      //   }

      // console.log({ params });

      const response = await axiosToken.get("/payments/only/vente", { params });
      const salesData = response.data?.data || [];

      set({
        sales: salesData,
        isLoadingSales: false,
      });

      return salesData;
    } catch (error) {
      console.error("Erreur getSalesWithDateRange :", error);
      toast.error(
        error?.response?.data?.error ||
          "Erreur lors du chargement des paiements.",
      );
      set({ isLoadingSales: false });
      return [];
    }
  },

  // Récupérer les achats avec today/tomorrow par défaut
  getUserPurchasesWithDateRange: async (startDate = null, endDate = null) => {
    set({ isLoadingPurchases: true });

    try {
      const params = {};

      // Par défaut: aujourd'hui et demain
      const today = new Date();
      const tomorrow = new Date(today);
      const lastday = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      lastday.setDate(lastday.getDate() - 1);

      if (startDate || endDate) {
        params.startDate = startDate || lastday.toISOString().split("T")[0];
        params.endDate = endDate || tomorrow.toISOString().split("T")[0];
      } else {
        // params.startDate = today.toISOString().split('T')[0];
        // params.endDate = tomorrow.toISOString().split('T')[0];
      }

      // console.log({ params });

      const response = await axiosToken.get("/payments/current/user", {
        params,
      });
      const purchasesData = response.data?.data || [];

      set({
        allPurchasesUser: purchasesData,
        isLoadingPurchases: false,
      });

      return purchasesData;
    } catch (error) {
      console.error("Erreur getSalesWithDateRange :", error);
      toast.error(
        error?.response?.data?.error ||
          "Erreur lors du chargement des paiements.",
      );
      set({ isLoadingPurchases: false });
      return [];
    }
  },

  // Fonction pour récupérer tous les paiements
  getAllPayments: async (startDate = null, endDate = null) => {
    set({ isLoadingPayments: true });
    const params = {};

    // Par défaut: aujourd'hui et demain
    const today = new Date();
    const tomorrow = new Date(today);
    const yesterday = new Date(today);

    today.setUTCHours(0, 0, 0, 0);
    tomorrow.setUTCHours(0, 0, 0, 0);
    yesterday.setUTCHours(0, 0, 0, 0);

    tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
    yesterday.setUTCDate(yesterday.getUTCDate() - 1);

    params.startDate = startDate || today.toISOString();

    if (endDate) {
      params.endDate = endDate;
    } else {
      const newDate = new Date(params.startDate);
      const nextDay = new Date(newDate);
      nextDay.setUTCHours(0, 0, 0, 0);
      nextDay.setUTCDate(nextDay.getUTCDate() + 1);
      params.endDate = nextDay.toISOString();
    }

    console.log({ params });

    try {
      const response = await axiosToken.get("/payments/", { params });
      const paymentsData = response.data?.data || [];

      console.log({ paymentsData });
      set({
        allPayments: paymentsData,
        isLoadingPayments: false,
      });

      return paymentsData;
    } catch (error) {
      console.error("Erreur getAllPayments :", error);
      toast.error(
        error?.response?.data?.error ||
          "Erreur lors du chargement des paiements.",
      );
      set({ isLoadingPayments: false });
      return [];
    }
  },

  // Fonction pour récupérer uniquement les paiements
  getOnlyPayments: async () => {
    set({ isLoadingPayments: true });

    try {
      const response = await axiosToken.get("/payments/only/payment");
      const paymentsData = response.data?.data || [];

      set({
        payments: paymentsData,
        isLoadingPayments: false,
      });

      return paymentsData;
    } catch (error) {
      console.error("Erreur getOnlyPayments :", error);
      toast.error(
        error?.response?.data?.error ||
          "Erreur lors du chargement des paiements.",
      );
      set({ isLoadingPayments: false });
      return [];
    }
  },

  // Fonction pour récupérer uniquement les ventes
  getOnlySales: async () => {
    set({ isLoadingSales: true });

    try {
      const response = await axiosToken.get("/payments/only/vente");
      const salesData = response.data?.data || [];

      set({
        sales: salesData,
        isLoadingSales: false,
      });

      return salesData;
    } catch (error) {
      console.error("Erreur getOnlySales :", error);
      toast.error(
        error?.response?.data?.error || "Erreur lors du chargement des ventes.",
      );
      set({ isLoadingSales: false });
      return [];
    }
  },

  // Fonction pour créer un nouveau paiement/vente AVEC extraData
  createPayment: async (paymentData) => {
    set({ isLoadingCreatePayment: true });

    try {
      const response = await axiosToken.post("/payments/", paymentData);
      const newPayment = response.data?.data;

      // toast.success("Vente créée avec succès!");

      // Mettre à jour les listes localement
      set((state) => ({
        sales: [...state.sales, newPayment],
        allPayments: [...state.allPayments, newPayment],
        isLoadingCreatePayment: false,
      }));

      return newPayment;
    } catch (error) {
      console.error("Erreur createPayment :", error);
      toast.error(
        error?.response?.data?.error ||
          "Erreur lors de la création de la vente.",
      );
      set({ isLoadingCreatePayment: false });
      return null;
    }
  },

  // Synchroniser l'ajout d'une nouvelle vente
  syncAddNewSale: (newSale) => {
    set((state) => ({
      sales: [...state.sales, newSale],
      allPayments: [...state.allPayments, newSale],
    }));
  },

  // Fonction pour réinitialiser le store
  resetSalesStore: () => {
    set({
      payments: [],
      sales: [],
      allPayments: [],
      dailySummary: null,
      unpaidReservations: [],
      isLoadingPayments: false,
      isLoadingSales: false,
      isLoadingCreatePayment: false,
      isLoadingDailySummary: false,
      isLoadingUnpaidReservations: false,
    });
  },
}));

export default salesStore;
